import { FC } from "preact/compat";
import { NavLink, useLocation, useResolvedPath } from "react-router-dom";
import { MenuItemProps } from "./interfaces";
import cn from "classnames";

const CLS =
    "flex h-[34px] items-center px-2 py-1 capitalize transition-transform duration-300";

const MenuItem: FC<MenuItemProps> = ({
    item,
    index,
    menuHeight,
    isHorizontal,
    isReverse,
}) => {
    const location = useLocation();
    const path = useResolvedPath(item.link);
    const isActive = location.pathname === path.pathname;
    const { icon: Icon, link, name, disabled } = item;
    const Component = item.disabled ? "div" : NavLink;

    return (
        <div className="group relative">
            <Component
                to={link}
                className={cn(
                    CLS,
                    "relative z-[102]",
                    disabled
                        ? "text-gray-400"
                        : isActive
                          ? "text-sky-300"
                          : "text-white hover:text-gray-300",
                )}
            >
                <Icon width="18" height="18" className="fill-current" />
            </Component>
            {!isHorizontal && (
                <Component
                    to={link}
                    style={{
                        backgroundSize: `42px ${menuHeight.value}px`,
                        backgroundPosition: `0px ${
                            menuHeight.value - 4 - index * 34
                        }px`,
                    }}
                    className={cn(
                        "z-[101] absolute bottom-0 w-[220px] px-5 flex items-center bg-gradient-primary-to-b",
                        "font-bold invisible transition-all duration-100 opacity-0 pointer-events-none capitalize",
                        "group-hover:visible group-hover:pointer-events-auto group-hover:translate-x-0 group-hover:opacity-100",
                        index === 0 ? "h-[38px]" : "h-[34px]",
                        isReverse.value
                            ? "right-6 rounded-l-[25px] translate-x-8"
                            : "left-6 rounded-r-[25px] -translate-x-8",
                        disabled ? "text-gray-300" : "text-white",
                    )}
                >
                    <span>{name}</span>
                </Component>
            )}
        </div>
    );
};

export default MenuItem;
